import { Component, EventEmitter, inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { ErrorService } from '@portal-core/errors/services/error.service';
import { CancelableEvent } from '@portal-core/general/classes/cancelable-event';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { SnackBarAutoDismissDurationMS } from '@portal-core/ui/snack-bar/constants/snack-bar-auto-dismiss-duration.constant';
import { LoadingState } from '@portal-core/util/loading-state';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgIf, AsyncPipe } from '@angular/common';
import { ErrorsExpansionPanelComponent } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.component';
import { MatButton } from '@angular/material/button';
import { LoaderComponent } from '@portal-core/general/components/loader/loader.component';

@Component({
    selector: 'mc-user-password-reset-form',
    templateUrl: './user-password-reset-form.component.html',
    styleUrls: ['./user-password-reset-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, FormsModule, NgIf, ErrorsExpansionPanelComponent, MatButton, LoaderComponent, AsyncPipe]
})
export class UserPasswordResetFormComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly errorService = inject(ErrorService);
  private readonly snackBar = inject(MatSnackBar);
  @Input() licenseUser: LicenseUser;
  @Output() canceled: EventEmitter<void> = new EventEmitter<void>();
  @Output() resetting: EventEmitter<CancelableEvent> = new EventEmitter<CancelableEvent>();
  @Output() resetComplete: EventEmitter<void> = new EventEmitter<void>();

  savingState: LoadingState<string> = new LoadingState<string>();
  showCancelButton: boolean;
  ngOnInit() {
    this.showCancelButton = this.canceled.observers.length > 0;
  }

  onCancelClicked() {
    this.canceled.emit();
  }

  onSubmit() {
    const resettingEvent = new CancelableEvent();
    this.resetting.emit(resettingEvent);

    if (!resettingEvent.defaultPrevented) {
      this.savingState.update(true);

      this.authService.requestPasswordReset$(this.licenseUser.User.Email).subscribe(() => {
        this.savingState.update(false);

        this.snackBar.open('The password reset email has been sent.', 'OK', {
          duration: SnackBarAutoDismissDurationMS
        });

        this.resetComplete.emit();
      }, error => {
        this.savingState.update(false, 'Unable to send the password reset email.', this.errorService.getErrorMessages(error));
      });
    }
  }
}
